// Dependencies
import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

// Utils
import { Box, Text } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';

// Local Components

// Configs
import { MONTHLY_PAYMENT_GOAL, TOTAL_MORTGAGE_INTEREST } from '../goals';

import Recommendation from './recommendation/recommendation';

// CSS
import styles from './rc-results-panel-insight.module.less';

class RCResultsPanelInsight extends React.Component {
  static renderSection(header, body, className) {
    return (
      <Box className={styles['rc-rcpi-breakdown-section']}>
        {header ? (
          <Box marginTop={3} marginBottom={0}>
            <Text light>{header}</Text>
          </Box>
        ) : (
          <br />
        )}
        <Box
          className={classnames(
            styles['rc-rcpi-breakdown-section-value'],
            styles[`${className}`]
          )}
        >
          {body}
        </Box>
      </Box>
    );
  }

  renderRecommendation() {
    const {
      inputs: { howLongStay, refinanceGoal },
      outputs: {
        details: {
          savings: { monthlyPayment, totalSavings },
        },
      },
    } = this.props.data;

    let recommendation = 'no';

    if (
      (refinanceGoal === MONTHLY_PAYMENT_GOAL.value && monthlyPayment > 0) ||
      (refinanceGoal === TOTAL_MORTGAGE_INTEREST.value && totalSavings > 0)
    ) {
      recommendation = 'yes';
    }

    return (
      <Box className={styles['rc-rcpi-recommendation']}>
        <Recommendation
          recommendation={recommendation}
          howLongStay={howLongStay}
          isSignedIn={this.props.isSignedIn}
        />
      </Box>
    );
  }

  render() {
    const {
      className,
      data: {
        outputs: {
          details: {
            currentLoan,
            refinanceLoan,
            savings: { monthlyPayment },
          },
        },
      },
    } = this.props;

    const newPayment = num
      .formatCurrency(refinanceLoan.monthlyPayment, false)
      .replace(/^\$/, '');
    const oldPayment = num
      .formatCurrency(currentLoan.monthlyPayment, false)
      .replace(/^\$/, '');
    const absPaymentNoDollar = num
      .formatCurrency(Math.abs(monthlyPayment), false)
      .replace(/^\$/, '');

    return (
      <Box
        className={classnames(
          styles['rc-rcpi contextual-recos'],
          styles[`${className}`]
        )}
      >
        <Box className={styles['rc-rcpi-breakdown-wrapper']}>
          <Text bold>Monthly payment savings breakdown</Text>
          <Box className={styles['rc-rcpi-breakdown']}>
            {RCResultsPanelInsight.renderSection('CURRENT', `$${oldPayment}`)}
            {RCResultsPanelInsight.renderSection(null, '-', 'symbol')}
            {RCResultsPanelInsight.renderSection('NEW', `$${newPayment}`)}
            {RCResultsPanelInsight.renderSection(null, '=', 'symbol')}
            {RCResultsPanelInsight.renderSection(
              'SAVINGS',
              `${monthlyPayment < 0 ? '-' : '+'}$${absPaymentNoDollar}`,
              monthlyPayment >= 0 ? 'positive' : 'negative'
            )}
          </Box>
        </Box>
        {this.renderRecommendation()}
      </Box>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RCResultsPanelInsight.displayName = 'RCResultsPanelInsight';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RCResultsPanelInsight.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string,
  isSignedIn: PropTypes.bool.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RCResultsPanelInsight.defaultProps = {
  className: null,
};

export default RCResultsPanelInsight;
